export const ADMIN_RECOMMENDATIONS = {
  active:
    'Administrators can send announcements to an entire community and manage other school communication with Remind Hub.',
  emerging:
    'Administrators can automatically create effective communication channels for every class in a school with Remind Hub.',
  engaged:
    'Administrators can use the community engagement statistics available with Remind Hub to set school goals and track progress.',
  growing:
    'Administrators can automatically provision two-way communication for everyone in a community through Remind Hub.',
};

export const TEACHER_RECOMMENDATIONS = {
  active:
    'To deepen engagement, teachers and staff members can send class announcements on Remind on a regular basis.',
  emerging:
    'To build a strong foundation for engagement, teachers and staff members can create free Remind accounts for their classes.',
  engaged:
    'To sustain engagement, teachers and staff members can enable two-way messaging and set up app integrations on Remind.',
  growing:
    'To foster engagement, teachers and staff members can invite students and parents to join their classes on Remind.',
};
